import { FC, useEffect, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkItemState } from '@robocorp/robocloud-orchestrator-interface';
import { defaultWorkItemsData, useWorkItemsLazyQuery } from '~/queries';
import { ApiHelperContext } from '../context';
import { ApiHelperSelectInput, ApiHelperSelectInputWrapperProps } from './ApiHelperSelectInput';

export const SelectWorkItem: FC<ApiHelperSelectInputWrapperProps> = ({
  value,
  setValue,
  pathParameters: { process_id: processId },
  ...props
}) => {
  const { endpoint } = useContext(ApiHelperContext);
  const { t } = useTranslation();

  const [
    { data: { data: workItems } = defaultWorkItemsData, isInitialLoading: isLoadingWorkItems },
    getWorkItems,
  ] = useWorkItemsLazyQuery();

  useEffect(() => {
    if (!processId) return;
    getWorkItems({ scope: 'process', processId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processId]);

  const processWorkItems = useMemo(() => {
    if (!workItems) {
      return [];
    }

    let items = workItems;

    if (endpoint.path.includes('/{file_id}')) {
      items = workItems.filter((item) => item.files && item.files.length > 0);
    }
    if (endpoint.path.includes('/retry')) {
      items = workItems.filter((item) => item.state === WorkItemState.Failed);
    }
    if (endpoint.path.includes('/complete')) {
      items = workItems.filter((item) => item.state === WorkItemState.Pending);
    }

    return items.map(({ id }) => {
      return { label: id, value: id };
    });
  }, [endpoint, workItems]);

  let placeholder = t('noWorkItems');

  if (endpoint.path.includes('/{file_id}')) {
    placeholder = t('noWorkItemsWithFiles');
  }
  if (endpoint.path.includes('/retry')) {
    placeholder = t('noFailedWorkItems');
  }
  if (endpoint.path.includes('/complete')) {
    placeholder = t('noFailedWorkItems');
  }

  return (
    <ApiHelperSelectInput
      label={t('chooseWorkItem')}
      items={processWorkItems}
      onChange={(value) => setValue('work_item_id', value)}
      loading={isLoadingWorkItems}
      value={value}
      noItemsFound={placeholder}
      {...props}
    />
  );
};
